import React, { useContext, useMemo, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, Typography } from '@mui/material';
import { LoadingButton } from "@mui/lab";

import { Utils } from "common/Utils";

import { useTheme } from '@mui/material/styles';

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export default function ClientAcknowledgementDialog({doShow, acknowledgement, handleSubmit, handleClose}) {
  const { userInfo } = useContext(PrivateRoutesContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDeferring, setIsDeferring] = useState(false);

    const isAcknowledged = useMemo(() => {
      return (acknowledgement && acknowledgement.user && acknowledgement.date) != null
    },[acknowledgement]);

    const canAcknowledge = useMemo(() => {
      return Utils.isEmployer(userInfo);
    },[userInfo]);

    const theme = useTheme();

    const onSubmit = () => {
        setIsSubmitting(true);

        handleSubmit(true, () => setIsSubmitting(false));
    }

    const onDefer = () => {
        setIsDeferring(true);

        handleSubmit(false, () => setIsDeferring(false));
    }

    return (
      <Dialog
        open={doShow}
        maxWidth={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Typography align="center" variant="h4">
            Client Acknowledgement
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box className="container">
            <Box className="row">
              <Box className="col-7">
                <Typography variant="h6" fontWeight="600">
                  As we prepare for your implementation, please be aware that AXIM will need the following documents. Supplying these documents in a timely manner will ensure a speedy implementation process:
                </Typography>
                <List
                  sx = {{
                    listStyleType: 'disc',
                    pl: 2,
                    '& .MuiListItem-root': {
                      display: 'list-item',
                    },
                  }}>
                  <ListItem>Company Information (Location, SIC or Nature of Business, # of employees)</ListItem>
                  <ListItem>Complete Census (Including Dependents and their election tier whether Enrolled or Waived)</ListItem>
                  <ListItem>Current Benefit Offerings w/ Carrier Information and Contacts – (Medical, Ancillaries, 401k)</ListItem>
                  <ListItem>Rate Tables on BRD (if combo one for SCA and one for non-SCA)</ListItem>
                  <ListItem>Carrier Invoices with member level Detail</ListItem>
                  <ListItem>Contracts and Wage Determinations</ListItem>
                  <ListItem>Payroll Calendar</ListItem>
                  <ListItem>Hours file Sample from your payroll system</ListItem>
                  <ListItem>Hi-resolution company logo</ListItem>
                </List>
              </Box>
              <Box className="col-5">
                <Box className="p-2" sx={{ marginTop: "20%", backgroundColor: theme.palette.primary.veryLight }}>
                  <Typography variant="h6" fontWeight="600">Monthly Client Deliverables:</Typography>
                  <List
                    sx = {{
                      listStyleType: 'disc',
                      pl: 2,
                      ml: 2,
                      '& .MuiListItem-root': {
                        display: 'list-item',
                      },
                    }}>
                    <ListItem>Hours Report (by the 10th of the month)</ListItem>
                    <ListItem>New Hire Census/ Termination Census</ListItem>
                    <ListItem>PTO Payout Report (for above and beyond contract requirements) - <i>if applicable</i></ListItem>
                    <ListItem>401k Match - <i>if applicable</i></ListItem>
                  </List>
                </Box>
              </Box>
              <Box className="col-12">
                <Typography variant="h6" fontWeight="600" sx={{ color: theme.palette.secondary.main }}>
                  Monthly Client deliverables are due by the <u>10th</u> of the month and can be uploaded in FringeSecure.
                </Typography>
              </Box>
              {isAcknowledged ?
              <Box className="col-12">
                <Typography align="right">
                  {`Acknowledged by ${acknowledgement.user} on ${Utils.formatDate(acknowledgement.date)}`}
                </Typography>
              </Box> : null}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
            {isAcknowledged || !canAcknowledge ?
                <Button variant="outlined" color="primary" onClick={handleClose}>
                    Close
                </Button>
            :
                <>
                    <LoadingButton
                        variant="outlined"
                        color="primary"
                        onClick={onSubmit}
                        startIcon={<CheckIcon />}
                        loading={isSubmitting}
                        loadingPosition="start"
                        disabled={isDeferring}
                    >
                        I Understand
                    </LoadingButton>
                    <LoadingButton
                        variant="outlined"
                        color="primary"
                        onClick={onDefer}
                        startIcon={<CloseIcon />}
                        loading={isDeferring}
                        loadingPosition="start"
                        disabled={isSubmitting}
                    >
                        Defer
                    </LoadingButton>
                </>
            }
        </DialogActions>
      </Dialog>
    )
}